export enum ExportType {
  EXCEL = 'EXCEL',
  ACR = 'ACR',
  ACR_ASYNC_ACTIVITY = 'ACR-ASYNC-ACTIVITY',
  ACTION_STATUS = 'action',
  ACTOR = 'actor',
  ACTIVITY_ID = 'id'
}
